import { ApiResult, request, safeRequest } from '@synergy/api';

import { HeaderBanner } from '../models/header-banner';
import { HeaderBannerDetailRequest } from '../models/header-banner-detail-request';

export class HeaderBannerDetailApi {
    constructor(protected baseUrl: string) {}

    public getHeaderBannerDetail(id: number): Promise<ApiResult<HeaderBanner>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/header-banners/${id}`),
            response => response.data
        );
    }

    public updateHeaderBannerDetail = (headerBanner: HeaderBannerDetailRequest): Promise<ApiResult<HeaderBanner>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/header-banners/${headerBanner.id}`, headerBanner),
            response => response.data
        );
    };

    public createHeaderBannerDetail = (headerBanner: HeaderBannerDetailRequest): Promise<ApiResult<HeaderBanner>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/header-banners`, headerBanner),
            response => response.data
        );
    };
}
